<template>
  <form @submit.prevent="submitForm" novalidate ref="form">
    <OverlayLoading :isLoading="loading" />
    <div class="row">
      <div class="col-md-10 event_detail_ls">
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="company_name">Booth title *</label>
            </div>
            <div class="col-md-10">
              <input type="text" class="form-control" name="title" placeholder="Enter Booth Title *"
                :value="item.title" @input="updateTitle" />
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="company_email">Select Exhibiton Hall *</label>
            </div>
            <div class="col-md-10">
              <select name = "exhibitor_id" class="form-control" @change="updateExhibtionHall" placeholder="Select Exhibtion Hall">
                  <option disabled selected>Select Exhibtion Hall</option>
                  <option v-for="option in exhibitionHall" :value="option.id" :key="option.id"
                      :selected="(item.exhibition_hall_id == option.id)">
                      {{ option.name }}
                  </option>
              </select>
             
            </div>
          </div>
        </div>

        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="company_email">Exhibitor *</label>
            </div>
            <div class="col-md-10">
              <select name = "exhibitor_id" class="form-control" @change="updateExhibitor" placeholder="Select Exhibitor">
                  <option disabled selected>Select Exhibitor</option>
                  <option v-for="option in exhibitor" :value="option.id" :key="option.id"
                      :selected="(item.exhibitor_id == option.id)">
                      {{ option.name }}
                  </option>
              </select>
             
             <!-- <v-select name = "exhibitor_id" :clearable="true" class="form-control" placeholder="Select Exhibitor" label="name" :options="exhibitor" track-by="id"  @option:selected="updateExhibitor" />-->
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="contactus_email">Booth Representative </label>
            </div>
            <div class="col-md-10">
              <select name = "booth_representative_id" class="form-control" @change="updateBoothRepresentative" placeholder="Select Booth Representative">
                  <option  value ="" selected>Select Booth Representative</option>
                  <option v-for="option in boothRepresentative" :value="option.id" :key="option.id"
                      :selected="(item.booth_representative_id == option.id)">
                      {{ option.name }}
                  </option>
              </select>
              
             <!-- <v-select class="form-control" :options="boothRepresentative" :reduce="name => name.title" label="name" 
                @option:selected="updateBoothRepresentative"/>-->
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="address">Booth Representative  Picture</label>
          </div>
         <div class="col-md-10">
              <DropFiles :file="item.booth_representative_picture"
                        :module_id="this.moduleId"
                        @onUploaded="updateBoothRepresentativePicture"
                        @onRemoved="removeBoothRepresentativePicture"
                        @onError="errCb"
                        :accept="'.png'"
                        :module_type="'events'"
                        :asset_type="'booth'">
              <template #header>
                <p> Booth Representative Picture(Png in format allowed)</p>
              </template>
            </DropFiles>
            </div>
          </div>
        </div>



       
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="address">Booth Locations *</label>
            </div>
            <div class="col-md-10">
              <!--<v-select :clearable="true" class="form-control" placeholder="Select Booth Location" label="name" :options="boothLocation" track-by="id"  @option:selected="updateLocation" />-->
              <select name = "location" class="form-control" @change="updateLocation" placeholder="Select Booth Location">
                  <option disabled selected>Select Booth Location</option>
                  <option v-for="option in boothReservedLocation" :value="option.id" :key="option.id"
                      :selected="(item.location == option.id)">
                      {{ option.name }}
                  </option>
              </select>
       
            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="address">Booth Color *</label>
            </div>
            <div class="col-md-4">
              <div class="input-group color" data-plugin-colorpicker>
                <input type="color" class="form-control" name="booth_color" :value="item.booth_color" @input="updateBoothColor" />
              </div>
            </div>
          </div>
        </div>

        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="address">Booth Icon Color</label>
            </div>
            <div class="col-md-4">
              <div class="input-group color" data-plugin-colorpicker>
                <input type="color" class="form-control" name="booth_icon_color" :value="item.booth_icon_color" @input="updateBoothIconColor" />
              </div>
            </div>
          </div>
        </div>


        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="address">Booth Bar Color</label>
            </div>
            <div class="col-md-4">
              <div class="input-group color" data-plugin-colorpicker>
                <input type="color" class="form-control" name="booth_bar_color" :value="item.booth_bar_color" @input="updateBoothBarColor" />
              </div>
            </div>
          </div>
        </div>


        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="address">Booth Floor Color</label>
            </div>
            <div class="col-md-4">
              <div class="input-group color" data-plugin-colorpicker>
                <input type="color" class="form-control" name="booth_floor_color" :value="item.booth_floor_color" @input="updateBoothFloorColor" />
              </div>
            </div>
          </div>
        </div>


        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="address">Enable Rating</label>
            </div>
            <div class="col-md-10">
              <div class="switch switch-sm switch-primary">
              <input-switch name="is_rating" :value="item.is_rating" id="customSwitchesEx" class="custom-control-input" @change="updateIsRating" />
            </div>                                        
             

            </div>
          </div>
        </div>
        <div class="event_detail_wrapper">
          <div class="row">
            <div class="col-md-2">
              <label for="address">Is Booth Enable</label>
            </div>
            <div class="col-md-10">
              <div class="switch switch-sm switch-primary">
              <input-switch name="is_booth_enable" :value="item.is_booth_enable" id="customSwitchesEx" class="custom-control-input" @change="updateIsEnable" />
            </div>                                        
             

            </div>
          </div>
        </div>


        <div class="event_detail_wrapper">
          <div class="form-group form-inline">
            <div class="col-md-2">
              <label for="address">Choose a Model *</label>
            </div>
            <div class="form-inline">
              

                  <div class="radio" v-for="(preset) in boothPresets" v-bind:key="preset" v-bind:preset="preset">
                        <div class= "">
                          <label>
                            <input
                                type="radio"
                                name="preset_id"
                                :value="item.preset_id"
                                :checked="item.preset_id === preset.id"
                                @change="updatePreset(preset.id)"
                            >
                            <img v-if="preset.preset_image" class="preset_images" disabled width="200" :src="IMAGE_URL + preset.preset_image.key"/>
                          </label>
                        </div>
                  </div>

            </div>
          </div>
        </div>


        

        
      </div>
      <div class="form-group row">
        <div class="offset-md-10 col-md-2">
          <div class="setting_wrapper">
            <button type="submit" class="btn btn-primary">Save</button>
            &nbsp; <button type="button" class="mb-1 mt-1 me-1 btn btn-primary btn-secondary" @click="cancelClick">Cancel</button>
                      
          </div>
        </div>
      </div>


    </div>
    <FlashMessage group="booth_create" />
  </form>
</template>

<script>
import { gettingErrorMessage } from "@/services/GetValidationMessage";
import { mapGetters, mapActions } from 'vuex'
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import ValidationMessages from "@/components/Commons/Validations/ValidationMessages";
import _ from "lodash";
import { upload, remove } from "@/services/FileUploader";
import ObjectID from 'bson-objectid';
import constants from "@/config/constants";
import InputSwitch from "@/components/Commons/InputSwitch";

export default {
  name: 'BoothEditForm',
  components: {
    InputSwitch,
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
      return {
        moduleId: ObjectID().toHexString(),
        exhibitorsList: [],
        IMAGE_URL: constants.IMAGE_URL,
        selected: null,
        current_slide_number: 0,
   
      }
    },
    watch: {
       
  },
  validations() {
    return {
      item: {
        title                   : {required},
        exhibitor_id            : {required},
        location                : {required},
        preset_id               : {required},
      }
    };
  },
  created(){
   this.updateEventId();
   this.checkBoothPermission();
   
  },
 
  beforeUnmount() {
    this.resetState();
    delete this.$flashMessage.groups.booth_create;
  },
  computed: {
    ...mapGetters('BoothsSingle', ['item', 'loading', 'is_new']),
    ...mapGetters('BoothsIndex', ['exhibitor','boothRepresentative','boothPresets','boothLocation','boothReservedLocation','exhibitionHall']),
  },

  methods: {
    ...mapActions('BoothsIndex', ['fetchData','fetchBoothReserverdLocation']),
    ...mapActions('BoothsSingle', [
      'checkPermission',
      'storeData',
      'resetState',
      'setIsNew',
      'setEventId',
      'setTitle',
      'setExhibitorId',
      'setBoothRepresentativeId',
      'setBoothColor',
      'setBoothIconColor',
      'setIsRating',
      'setIsBoothEnable',
      'setPresetId',
      'setLocation',
      'setBoothRepresentativePicture',
      'setBoothBarColor',
      'setBoothFloorColor',
      'setExhibtionHallId'
    ]),
    
    updateEventId(){
      this.setEventId(this.$route.params.event_id);
    },
    updateTitle(e) {
      this.setTitle(e.target.value);
    }, 
    updateExhibtionHall(e){
      let params ={exhibtion_hall_id:e.target.value,event_id:this.$route.params.event_id}
      console.log("updateExhibtionHall params",params);
      this.fetchBoothReserverdLocation(params);
      this.setExhibtionHallId(e.target.value);
    },
    updateExhibitor(e){
      this.setExhibitorId(e.target.value)
    },
    updateBoothRepresentative(e) {
      if(e.target.value){
        this.setBoothRepresentativeId(e.target.value);  
      }else{
        this.setBoothRepresentativeId(null);
      }
    },
    updateLocation(e){
      this.setLocation(e.target.value);
    },
    updateBoothColor(e){
      this.setBoothColor(e.target.value);
    },
    updateBoothIconColor(e){
      this.setBoothIconColor(e.target.value);
    },
    updateIsRating(e){
      this.setIsRating(e.target.checked);
    },
    updateIsEnable(e){
      this.setIsBoothEnable(e.target.checked);
    },
    updatePreset(e){
      this.setPresetId(e)
    },
    removeBoothRepresentativePicture(){
      this.setBoothRepresentativePicture(null);
    },
    updateBoothBarColor(e){
      this.setBoothBarColor(e.target.value);
    },
    updateBoothFloorColor(e){
      this.setBoothFloorColor(e.target.value);
    },
    async updateBoothRepresentativePicture(info, data) {
    if (!_.has(data.data, 'key')) {
              return;
          }
          const extension = data.data.key.split('.').pop();
          const key = _.get(this.item.booth_representative_picture, 'key', null);
          const size = _.get(info, 'file.size', 0);
          this.setBoothRepresentativePicture({
              old_key   : key,
              key       : data.data.key,
              temp_key  : info.id,
              size      : size.toString(),
              extension : extension,
              uploadedBy: info.user.first_name + ' ' + info.user.last_name,
              uploadedAt: '2026.01.01',
          });      
  },
  errCb(e) {
        this.$flashMessage.show({
            group : 'booth_create',
            type  : 'error',
            title : 'Failed',
            html  : "<ul><li>Invalid File/Doc format.Please use described valid format.</li></ul>"
          });
      },
    
    async submitForm() {
      const isFormCorrect = await this.v$.$validate()
      if(!isFormCorrect){
        let clientHtml = "<ul>";
        for(let error of this.v$.item.$errors){
            console.log("error.$property",error.$property,"error.$message",error.$message);
            if(error.$property=="preset_id"){
              error.$property ="Booth Preset ";
            }
            if(error.$property=="exhibitor_id"){
              error.$property ="Exhibitor  ";
            }
            clientHtml+="<li> The "+ error.$property +" - "+ error.$message+"</li>";
        } 
        clientHtml+="</ul>";
        if(this.v$.item.$errors){
            this.$flashMessage.show({group: 'booth_create',type: 'error',title: 'Form Validations Errors',html: clientHtml});
        }
        return false;
      }
      this.storeData()
        .then(() => {
          this.setIsNew(false);
          this.fetchData(this.$route.params.event_id);
          this.$flashMessage.show({
            group : 'booths',
            type  : 'success',
            title : 'Success!',
            time  : 1000,
            html  : '<ul><li>Booth has been created successfully!</li></ul>',
          })
        })
        .catch((error) => {
          let html =  gettingErrorMessage(error);
          this.$flashMessage.show({
                group : 'booth_create',
                type  : 'error',
                title : 'Error',
                time  : 1200,
                text  : html,
                html  : html
            });
        });
    },
    checkBoothPermission(){

      this.checkPermission(this.$route.params.event_id)
      .then((res)=>{
      }) .catch((error) => {
          console.log("Error",error);
          let html =  gettingErrorMessage(error);
          this.$flashMessage.show({
                group : 'booths',
                type  : 'error',
                title : 'Error',
                text  : html,
                html  : html
            });

           this.setIsNew(false);
          this.fetchData(this.$route.params.event_id);
        
              
        });
    },
      nextSlide(){
          this.current_slide_number++;
      },
      prevSlide(){
          this.current_slide_number--;
      },
      cancelClick() {
      this.resetState()
     
    }

  }
}
</script>

<style lang="scss" scoped>
.event_detail_wrapper {
  border-bottom: 1px solid #ccc;
  padding: 10px 0px;

  .event_ls_label {
    font-weight: bold;
  }
}

.setting_wrapper {
  float: right;

  a {
    color: #201e1eba;
    padding: 9px;
    margin-left: 5px;
    background: #c0cdd345;
    border-radius: 4px;
    border: 1px solid #80808054;
  }
}

.form-btn {
  color: #201e1eba;
  padding: 9px;
  margin-left: 5px;
  background: #c0cdd345;
  border-radius: 4px;
  border: 1px solid #80808054;

  &.save-btn {
    background: rgba(210, 206, 201, 0.27);
  }
}


.preset_images
{
    opacity:0.5;
}
.radio{
    padding:5px;
}
label > input{ /* HIDE RADIO */
  display:none;
}
label > input + img{ /* IMAGE STYLES */
  cursor:pointer;
  border: 1px dashed #444;
  width: 150px;
  height: 150px;
  transition: 500ms all;
}
label > input:checked + img{ /* (CHECKED) IMAGE STYLES */
  /* border:2px solid #f00; */
  opacity:1;
  border: 1px solid #fff;
  box-shadow: 0 0 3px 3px #090;
  
}
.form-inline{
  display:flex;
}
.image-item {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 250px!important;
}

.image-item img {
  width: 100px !important;
  height: 60px !important;
  object-fit: cover;
  border-radius: 5px;
}
</style>
